.wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--tempest-space-3);
    padding: var(--tempest-space-3) 0;
    font-family: var(--tempest-font-sans);
    font-size: var(--tempest-text-sm);
    color: var(--tempest-text-muted);
    flex-wrap: wrap;
}

.controls {
    display: flex;
    align-items: center;
    gap: var(--tempest-space-1);
    min-width: 0;
}

.page {
    min-width: 32px;
    height: 32px;
    padding: 0 var(--tempest-space-2);
    border: 1px solid var(--tempest-border);
    background-color: var(--tempest-bg);
    color: var(--tempest-text);
    border-radius: var(--tempest-radius-md);
    font-family: inherit;
    font-size: var(--tempest-text-sm);
    font-weight: var(--tempest-weight-medium);
    transition: var(--tempest-transition-color);
}

@media (hover: hover) and (pointer: fine) {
    .page:hover:not(:disabled) {
        background-color: var(--tempest-surface);
        border-color: var(--tempest-border-strong);
    }
    .active:hover {
        background-color: var(--tempest-primary-hover);
        border-color: var(--tempest-primary-hover);
    }
}

.page:focus-visible {
    outline: var(--tempest-focus-ring-width) solid var(--tempest-focus-ring-color);
    outline-offset: var(--tempest-focus-ring-offset);
}

.page:disabled {
    opacity: 0.45;
    cursor: not-allowed;
}

.active {
    background-color: var(--tempest-primary);
    border-color: var(--tempest-primary);
    color: var(--tempest-primary-foreground);
}

.ellipsis {
    padding: 0 var(--tempest-space-2);
    color: var(--tempest-text-subtle);
}

.sizeSelect {
    height: 32px;
    padding: 0 var(--tempest-space-2);
    border: 1px solid var(--tempest-border);
    border-radius: var(--tempest-radius-md);
    background-color: var(--tempest-bg);
    color: var(--tempest-text);
    font-family: inherit;
    font-size: var(--tempest-text-sm);
}

.sizeSelect:focus-visible {
    outline: var(--tempest-focus-ring-width) solid var(--tempest-focus-ring-color);
    outline-offset: var(--tempest-focus-ring-offset);
}

@media (max-width: 639.98px) {
    .summary {
        font-size: var(--tempest-text-xs);
    }

    .wrapper[data-compact="true"] .numeric,
    .wrapper[data-compact="true"] .sizeSelect {
        display: none;
    }

    .wrapper[data-compact="true"] .controls {
        flex: 1;
        justify-content: space-between;
    }

    .wrapper[data-compact="false"] .controls {
        flex: 1 1 100%;
        justify-content: flex-start;
        overflow-x: auto;
        overscroll-behavior-x: contain;
        scrollbar-width: thin;
        scroll-padding-inline: var(--tempest-space-2);
        padding-block-end: var(--tempest-space-1);
    }

    .wrapper[data-compact="false"] .page,
    .wrapper[data-compact="false"] .ellipsis,
    .wrapper[data-compact="false"] .sizeSelect {
        flex: 0 0 auto;
    }
}
